<app-title-section></app-title-section>

<div class="card p-1 gs-dashboard-page">
  <app-logiciel-caisse-pos-filters
    #filters
    [showDateFilter]="true"
    [showWarehouseFilter]="false"
    dateFilterStorageKey="achat-dashboard"
    searchPlaceholder=""
    (filtersChange)="onFiltersChange($event)"
  ></app-logiciel-caisse-pos-filters>

  <div *ngIf="!stationId" class="card-body">
    <div class="alert alert-warning mb-0">
      Aucune station active. Sélectionnez une station depuis le hub pour afficher les indicateurs achat.
    </div>
  </div>

  <div *ngIf="loading" class="card-body gs-dashboard-loading" aria-busy="true" aria-live="polite">
    <div class="gs-dashboard-skeleton">
      <div class="gs-dashboard-skeleton__kpis">
        <span *ngFor="let _ of [1,2,3,4,5,6]" class="gs-dashboard-skeleton__kpi"></span>
      </div>
      <div class="gs-dashboard-skeleton__charts">
        <span *ngFor="let _ of [1,2]" class="gs-dashboard-skeleton__chart"></span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading && stationId && (erp || facturesGlobales)">
    <div class="card-body gs-dashboard-meta">
      <small class="text-muted">
        Période :
        {{ (erp?.filters?.date_from || dateFrom) | date:'dd/MM/yyyy' }} →
        {{ (erp?.filters?.date_to || dateTo) | date:'dd/MM/yyyy' }}
      </small>
    </div>

    <div class="card-body pb-0" *ngIf="erp">
      <p class="gs-section-title mb-0">Documents achat (ERP)</p>
    </div>
    <div class="card-body row gs-dashboard-kpis" *ngIf="erp">
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-primary">
          <div class="card-body">
            <h6>Commandes fournisseur</h6>
            <h3>{{ erp.kpis.commande_fournisseur.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.commande_fournisseur.pending }} en cours (tous)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-success">
          <div class="card-body">
            <h6>Bons réception</h6>
            <h3>{{ erp.kpis.bon_reception.period | number:'1.0-0' }}</h3>
            <small>
              {{ erp.kpis.bon_reception.pending_a_receptionner }} à réceptionner ·
              {{ erp.kpis.bon_reception.pending_en_controle }} en contrôle
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-warning">
          <div class="card-body">
            <h6>Factures fournisseur</h6>
            <h3>{{ erp.kpis.facture_fournisseur.period | number:'1.0-0' }}</h3>
            <small>
              {{ erp.kpis.facture_fournisseur.pending_non_payee }} non payées ·
              {{ erp.kpis.facture_fournisseur.pending_brouillon }} brouillon
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-danger">
          <div class="card-body">
            <h6>Retours fournisseur</h6>
            <h3>{{ erp.kpis.retour_fournisseur.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.retour_fournisseur.pending }} en cours</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-info">
          <div class="card-body">
            <h6>Avoirs fournisseur</h6>
            <h3>{{ erp.kpis.avoir_fournisseur.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.avoir_fournisseur.pending }} non / partiellement utilisés</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-secondary">
          <div class="card-body">
            <h6>Actions en attente</h6>
            <h3>{{ erp.kpis.pending_actions_total | number:'1.0-0' }}</h3>
            <small>Workflow achat ouvert (ERP)</small>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pb-0" *ngIf="facturesGlobales || reassort">
      <p class="gs-section-title mb-0">Synthèse achat</p>
    </div>
    <div class="card-body row gs-dashboard-kpis pt-1" *ngIf="facturesGlobales || reassort">
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="facturesGlobales">
        <div class="card bg-light-success">
          <div class="card-body">
            <h6>Factures payées (TTC)</h6>
            <h3>{{ formatTnd(facturesGlobales.factures_payees.total_ttc || 0) }}</h3>
            <small>{{ facturesGlobales.factures_payees.nombre | number:'1.0-0' }} document(s)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="facturesGlobales">
        <div class="card bg-light-danger">
          <div class="card-body">
            <h6>Factures à payer (TTC)</h6>
            <h3>{{ formatTnd(facturesGlobales.factures_a_payer.total_ttc || 0) }}</h3>
            <small>{{ facturesGlobales.factures_a_payer.nombre | number:'1.0-0' }} document(s)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="reassort">
        <div class="card bg-light-primary">
          <div class="card-body">
            <h6>Réassort en cours</h6>
            <h3>{{ reassort.en_cours | number:'1.0-0' }}</h3>
            <small>Transferts LC (origine réassort)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="reassort">
        <div class="card bg-light-secondary">
          <div class="card-body">
            <h6>Réassort clos</h6>
            <h3>{{ reassort.clos | number:'1.0-0' }}</h3>
            <small>Historique réassort achat</small>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body row gs-dashboard-charts">
      <div class="col-lg-12 mb-2" *ngIf="erp">
        <div class="card gs-chart-card">
          <div class="card-header">
            <h5 class="mb-0">Activité documents achat</h5>
            <small class="text-muted">Créations journalières sur la période</small>
          </div>
          <div class="card-body gs-chart-wrap gs-chart-wrap--multi-legend">
            <canvas
              baseChart
              [data]="erpAchatChart.data"
              [options]="erpAchatChart.options"
              [type]="erpAchatChart.type"
            ></canvas>
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2" *ngIf="facturesGlobales">
        <div class="card gs-chart-card">
          <div class="card-header">
            <h5 class="mb-0">Encours factures fournisseur</h5>
            <small class="text-muted">Montants TTC agrégés (toutes stations / fournisseurs)</small>
          </div>
          <div class="card-body gs-chart-wrap">
            <canvas
              baseChart
              [data]="facturesPaiementChart.data"
              [options]="facturesPaiementChart.options"
              [type]="facturesPaiementChart.type"
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="card-body" *ngIf="!loading && stationId && !erp && !facturesGlobales">
    <div class="alert alert-info mb-0">
      Aucune statistique achat disponible. Vérifiez la station et l’API
      <code>/api/documents/achat/dashboard-stats</code> sur backend-erp.
    </div>
  </div>
</div>
